import { useEffect, useState } from "react";

export default function ChurchImage( {photos} ) {
  const [index, setIndex] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % photos.length);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const current = photos[index];

  return (
    <div className="contact-image">
      <img
        src={current.src}
        alt={current.alt}
      />
    </div>
  );
}
